import { render, staticRenderFns } from "./AppNavigationSettings.vue?vue&type=template&id=e5a2e666&scoped=true&"
import script from "./AppNavigationSettings.vue?vue&type=script&lang=js&"
export * from "./AppNavigationSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationSettings.vue?vue&type=style&index=0&id=e5a2e666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a2e666",
  null
  
)

export default component.exports